import { CareRecipientId } from "../../../../domain/care_recipient/CareRecipientId";
import { CareRecipientMemo } from "../../../../domain/care_recipient_memo/CarerecipientMemo";
import { CareRecipientMemoContent } from "../../../../domain/care_recipient_memo/CarerecipientMemoContent";
import { CareRecipientMemoId } from "../../../../domain/care_recipient_memo/CareRecipientMemoId";
import { ApiPaths } from "../../../api/ApiPaths";
import { ApiRequest } from "../../../api/ApiRequest";

export type GetCareRecipientMemoListSuccessResponseType = {
    careRecipientMemoList: {
        id: string,
        careRecipientId: string,
        content: string,
        createdAt: string
    }[],
    // API処理結果判別用：OK->undefined、NG->ErrorResponseType
    error: undefined
};

export type RegisterCareRecipientMemoSuccessResponseType = {
    careRecipientMemo: {
        id: string,
        careRecipientId: string,
        content: string,
        createdAt: string
    },
    // API処理結果判別用：OK->undefined、NG->ErrorResponseType
    error: undefined
};

export type UpdateCareRecipientMemoSuccessResponseType = {
    careRecipientMemo: {
        id: string,
        careRecipientId: string,
        content: string,
        createdAt: string
    },
    // API処理結果判別用：OK->undefined、NG->ErrorResponseType
    error: undefined
};

export async function getCareRecipientMemoList(careRecipientId: CareRecipientId): Promise<GetCareRecipientMemoListSuccessResponseType> {
    return await ApiRequest.get(
        ApiPaths.admin.careRecipientMemoList,
        { "care_recipient_id": careRecipientId.value },
        () => {},
        () => {});
}

export async function registerCareRecipientMemo(careRecipientId: CareRecipientId, memoContent: CareRecipientMemoContent): Promise<RegisterCareRecipientMemoSuccessResponseType> {
    return await ApiRequest.post(
        ApiPaths.admin.careRecipientMemoRegister,
        {},
        {
            careRecipientId: careRecipientId.value,
            memoContent: memoContent.value
        },
        () => {},
        () => {}
    );
}

export async function updateCareRecipientMemo(careRecipientMemo: CareRecipientMemo): Promise<UpdateCareRecipientMemoSuccessResponseType> {
    return await ApiRequest.post(
        ApiPaths.admin.careRecipientMemoUpdate.replace(/\{careRecipientMemoId\}/g, careRecipientMemo.id.value),
        {},
        {
            careRecipientId: careRecipientMemo.careRecipientId.value,
            memoContent: careRecipientMemo.content.value,
            createdAt: careRecipientMemo.createdAt.format()
        },
        () => {},
        () => {}
    );
}

export async function deleteCareRecipientMemo(careRecipientMemoId: CareRecipientMemoId) {
    ApiRequest.delete(
        ApiPaths.admin.careRecipientMemoUpdate.replace(/\{careRecipientMemoId\}/g, careRecipientMemoId.value),
        {},
        () => {},
        () => {}
    );
}
